/**
 * Brand + social constants for the public site. Used to live in the
 * settings document, but the admin Settings UI was removed, so the values
 * are now part of the source. Edit this file (and redeploy) to change
 * them.
 *
 * `logo` / `logoWhite` resolve relative to /public, so dropping new files
 * in there with the same name updates the site without code changes.
 */
export const BRAND = Object.freeze({
  name: "Shere-e-Punjab Homes",
  legalName: "Shere-e-Punjab Homes Pty Ltd",
  tagline: "Bespoke custom homes, built by the team you talk to.",
  phone: "0434 109 135",
  mobile: "0434 109 135",
  email: "info@sherepunjab.au",
  address: "9 Westcott Drive, Lucas VIC 3350",
  logo: "/logo.png",
  logoWhite: "/logo-white.png",
  // Four regions we build across — surfaced as an emphasis line in the
  // header, footer, and contact blocks.
  serviceAreas: ["Melbourne", "Geelong", "Ballarat", "Bendigo"],
  serviceAreaLine: "Proudly building across Melbourne, Geelong, Ballarat & Bendigo",
});

// Hard-coded social URLs. Replace placeholders with real account URLs;
// leave a value as "" to hide the icon.
export const SOCIAL = Object.freeze({
  facebook: "https://www.facebook.com/",
  instagram: "https://www.instagram.com/",
  linkedin: "https://www.linkedin.com/",
  youtube: "https://www.youtube.com/",
  productReview: "",
});
